import React, {useCallback, useContext, useEffect, useState} from "react";
import {Pagination} from "../../shared/Pagination.jsx";
import {useNavigate, Link} from "react-router-dom";
import {Box, Grid} from "@mui/material";
import {UserContext} from "../../shared/Greet.jsx";
import {formatDate} from "../../services/utils.js";
import {Loading} from "../../shared/Loading.jsx";
import {getDeliveryOrders} from "./api.js";
import {fetchProducts} from "../../api.js";


export const formatOrderString = (itemsObject, productsData) => {
  if (!itemsObject || typeof itemsObject !== 'object') return 'Нет товаров';
  
  return Object.entries(itemsObject).map(([productId, quantity]) => {
    const product = productsData[productId];
    const productName = product?.short_description || `Товар ${productId}`;
    const measure = product?.measure || '';
    return `${productName} ${quantity}${measure}`;
  }).join(', ');
}

export const DeliveryOrdersList = () => {

  const navigate = useNavigate()

  const { user } = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  const [orders, setOrders] = useState([])
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [pagination, setPagination] = useState({})
  const [products, setProducts] = useState({})

  const updateOrdersList = useCallback(({limit, offset}) => {
    if(user.user_id){
      getDeliveryOrders({limit, offset, courierId: user.user_id}).then(({orders, pagination}) => {
        setOrders(orders)
        setPagination(pagination)
      })
    }
  }, [user])

  useEffect(() => {
    if(user.user_id){
      fetchProducts().then(setProducts).catch((error) => console.error(error));
    }
  }, [user]);
  
  useEffect(() => {
    if (user.user_id) {
      updateOrdersList({ limit, offset });
    }
  }, [user, limit, offset, updateOrdersList]);

  const goToOrder = (id) => {
    navigate(`/delivery-orders/${id}`)
  }

  return <Box component="form" sx={{ maxWidth: 600, margin: 'auto', padding: 2, bgColor: "fff" }}>
    <Grid container spacing={2}>
      <div style={{width: "100%"}}>
        <h2>Список моих заказов</h2>

        {loading && <Loading />}

        <div>
          {orders?.length ?
              <Pagination pagination={pagination} onChange={updateOrdersList} limit={limit} offset={offset}
                          setLimit={setLimit}
                          setOffset={setOffset}>
                <table className="drops-list">
                  <thead>
                  <tr>
                    <td>Заказ</td>
                    <td>Оператор</td>
                    <td>Статус</td>
                    <td>Действия</td>
                  </tr>
                  </thead>
                  <tbody>
                  {orders.map((order) => {
                    return <tr key={order.id} className="border-2">
                      <td>
                        {formatOrderString(order.items?.reduce((acc, item) => {
                          acc[item.productId] = item.quantity;
                          return acc;
                        }, {}), products)}
                      </td>
                      <td>
                        {order.operator_full_name || "Не назначен"}
                      </td>
                      <td>
                        {
                          order.cancelled_at ? (
                            <p>Отменен: {formatDate(order.cancelled_at)}</p>
                          ) : order.done_at ? (
                            <p>Выполнен: {formatDate(order.done_at)}</p>
                          ) : order.confirmed_at ? (
                            <p>Подтвержден: {formatDate(order.confirmed_at)}</p>
                          ) : (
                            <p>Создан: {formatDate(order.created_at)}</p>
                          )
                        }
                      </td>
                      <td>
                        <Link to={`/delivery-orders/${order.id}`}>
                          <button>Управлять</button>
                        </Link>
                      </td>
                    </tr>
                  })}
                  </tbody>
                </table>
              </Pagination> : <div className="mt-5">
                Заказов не найдено
              </div>}

      </div>
      </div>
    </Grid>
  </Box>
}
